import * as React from "react";
import { Grid } from "../grid/grid";
import { GridItem } from "../grid/griditem";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
import { isNullOrUndefined } from "../better/utils";
const toggleClass = css({
    border: "none",
    borderRadius: "0px",
    cursor: "pointer",
    boxSizing: "border-box",
    userSelect: "none",
});
const toggleSliderClass = css({
    cursor: "pointer",
    borderRadius: "50%",
    transition: ".4s",
    marginTop: "3px",
    marginLeft: "5px",
    width: "20px",
    height: "20px",
    backgroundColor: getThemeColorVar("white", undefined),
    border: "1px solid rgba(0,0,0, .3)",
});
const toggleSliderChecked = css({
    transform: "translateX(15px)",
});
const toggleSliderSmallClass = css({
    height: "16px",
    width: "16px",
    marginTop: 0,
    marginLeft: 0,
});
const railClass = css({
    width: "45px",
    height: "26px",
    cursor: "pointer",
    borderRadius: "15px",
    border: `2px solid ${getThemeColorVar("border", "default")}`,
    transition: ".4s",
});
const railUncheckedClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    transition: ".4s",
});
const railSmallClass = css({
    height: "16px",
    width: "31px",
    borderRadius: "8px",
    border: `1px solid ${getThemeColorVar("border", "default")}`,
});
export class Toggle extends React.Component {
    render() {
        const classes = [toggleClass];
        const railClasses = [railClass];
        const sliderClasses = [toggleSliderClass];
        if (isNullOrUndefined(this.props.whiteSpace)) {
            classes.push(css({ whiteSpace: "nowrap" }));
        }
        else {
            classes.push(css({ whiteSpace: this.props.whiteSpace }));
        }
        if (this.props.small) {
            sliderClasses.push(toggleSliderSmallClass);
            railClasses.push(railSmallClass);
        }
        this.props.color &&
            this.props.checked &&
            railClasses.push(css({
                backgroundColor: getThemeColorVar(this.props.color, this.props.colorType),
                transition: ".4s",
                borderStyle: "none",
            }));
        !this.props.checked && railClasses.push(railUncheckedClass);
        this.props.checked && sliderClasses.push(toggleSliderChecked);
        this.props.color &&
            this.props.checked &&
            this.props.small &&
            sliderClasses.push(css({
                borderColor: getThemeColorVar(this.props.color, this.props.colorType),
            }));
        if (this.props.disabled) {
            railClasses.push(css({ backgroundColor: getThemeColorVar("background", "light") }));
            classes.push(css({ cursor: "not-allowed" }));
        }
        return (React.createElement("div", { onClick: () => !this.props.disabled &&
                this.props.onChange &&
                this.props.onChange(!this.props.checked), className: cx("re-toggle", classes) },
            React.createElement(Grid, { columnSpec: "fit-content(100%) 1fr", gap: "md" },
                React.createElement(GridItem, { colStart: 1, rowStart: 1 },
                    React.createElement("div", { className: cx(railClasses) })),
                React.createElement(GridItem, { colStart: 1, rowStart: 1 },
                    React.createElement("input", { type: "hidden", id: this.props.id, name: this.props.name, value: this.props.checked ? "true" : "false", disabled: this.props.disabled })),
                React.createElement(GridItem, { colStart: 1, rowStart: 1 },
                    React.createElement("div", { className: cx(sliderClasses) }, " ")),
                this.props.label && (React.createElement(GridItem, { colStart: 2, rowStart: 1, alignSelf: "center", justifySelf: "start" },
                    React.createElement("div", null, this.props.label))))));
    }
}
Toggle.defaultProps = {
    checked: false,
    color: "primary",
    colorType: "default",
};
export default Toggle;
//# sourceMappingURL=toggle.js.map